export interface ProgressBarProps {
  value: number;
}

export default function ProgressBar({ value }: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div className="w-full bg-navy-700 rounded h-2 overflow-hidden shadow-inner" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.floor(pct)}>
      <div className="bg-yellow-400 h-2 transition-all duration-500 ease-out rounded-sm shadow-sm" style={{ width: `${pct}%` }} />
    </div>
  );
}


